import reducer from './reducer'
import * as StatisticsOperations from './operations'
import * as StatisticsUtils from './utils'
import * as StatisticsTypes from './types'
import * as StatisticsActions from './actions'

export { StatisticsOperations, StatisticsUtils, StatisticsTypes, StatisticsActions }

export default reducer
